import { h } from '@stencil/core';
import { HttpStatusCodes } from '@pes-ui/utils';
export class PesDocumentListing {
  constructor() {
    this.onDocumentsReceived = (e) => {
      const { documentcount, statuscode } = e.detail;
      const hasDocuments = documentcount > 0 && statuscode === HttpStatusCodes.OK;
      this.documentListingReady.emit({ hasDocuments, name: this.name });
      window.removeEventListener(e.type, this.onDocumentsReceived);
    };
    this.onAddToDocuments = (event) => {
      this.documentFavoriteCountChange.emit(event.detail.count);
    };
    this.name = undefined;
    this.apiEndpoint = undefined;
    this.documentDetailsUrl = undefined;
    this.enableDocumentDetailsUrl = false;
    this.country = undefined;
    this.language = undefined;
    this.pageType = undefined;
    this.resourceId = undefined;
    this.software = undefined;
    this.applicationSource = 'PES_SE';
    this.view = 'grid';
    this.documentsCardOnly = false;
    this.myFavorites = false;
    this.idmsToken = '';
    this.keyword = '';
    this.userProfile = '';
  }
  get fetchSoftwares() {
    return this.software ? 'only' : 'none';
  }
  get configuration() {
    const conf = [
      this.apiEndpoint,
      this.country.toLocaleLowerCase(),
      this.language.toLocaleLowerCase(),
      this.applicationSource,
      `${this.pageType}=${this.resourceId}`,
      `view=${this.view}|fetchSoftwares=${this.fetchSoftwares}`,
      `documentscardonly=${this.documentsCardOnly}`,
    ];
    conf.push(`accessToken=${this.idmsToken}`);
    conf.push(`keyword=${this.keyword}`);
    return conf.join('::');
  }
  render() {
    return (h("div", { class: "pes-document-listing" }, this.software ? (h("document-listing-web-component-software", { ref: () => {
        window.addEventListener('documentsReceivedSoftware', this.onDocumentsReceived);
        window.addEventListener('myDocumentsCountUpdateSoftware', this.onAddToDocuments);
      }, configuration: this.configuration, myfavorites: this.myFavorites ? 'true' : 'false', user: this.userProfile })) : (h("document-listing-web-component", { ref: () => {
        window.addEventListener('documentsReceived', this.onDocumentsReceived);
        window.addEventListener('myDocumentsCountUpdate', this.onAddToDocuments);
      }, configuration: this.configuration, myfavorites: this.myFavorites ? 'true' : 'false', user: this.userProfile }))));
  }
  static get is() { return "pes-document-listing"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-document-listing.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-document-listing.css"]
    };
  }
  static get properties() {
    return {
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Document listing component instance name (required if multiple components are used on the same page)."
        },
        "attribute": "name",
        "reflect": false
      },
      "apiEndpoint": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "This parameter contains the rest API URL."
        },
        "attribute": "api-endpoint",
        "reflect": false
      },
      "documentDetailsUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Value of this parameter is the URL of document details page."
        },
        "attribute": "document-details-url",
        "reflect": false
      },
      "enableDocumentDetailsUrl": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Enable the URL of document details page."
        },
        "attribute": "enable-document-details-url",
        "reflect": false,
        "defaultValue": "false"
      },
      "country": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Country code."
        },
        "attribute": "country",
        "reflect": false
      },
      "language": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Language code."
        },
        "attribute": "language",
        "reflect": false
      },
      "pageType": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'range' | 'product'",
          "resolved": "\"product\" | \"range\"",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Type of page on which we use the component."
        },
        "attribute": "page-type",
        "reflect": false
      },
      "resourceId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "ID of the range or of the product."
        },
        "attribute": "resource-id",
        "reflect": false
      },
      "software": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "If true, it shows only software and firmware, otherwise all other documents."
        },
        "attribute": "software",
        "reflect": false
      },
      "applicationSource": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Consumer application source."
        },
        "attribute": "application-source",
        "reflect": false,
        "defaultValue": "'PES_SE'"
      },
      "view": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'grid' | 'list' | 'smallcard'",
          "resolved": "\"grid\" | \"list\" | \"smallcard\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The value of this parameter determines the document card view."
        },
        "attribute": "view",
        "reflect": false,
        "defaultValue": "'grid'"
      },
      "documentsCardOnly": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Based on value of this parameter, web component shows either only document cards or all the document cards, pagination, filter and sorting."
        },
        "attribute": "documents-card-only",
        "reflect": false,
        "defaultValue": "false"
      },
      "myFavorites": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Flag which enable or disable add document to My favorites functionality."
        },
        "attribute": "my-favorites",
        "reflect": false,
        "defaultValue": "false"
      },
      "idmsToken": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Token provided by IDMS system for SSO."
        },
        "attribute": "idms-token",
        "reflect": false,
        "defaultValue": "''"
      },
      "keyword": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Search keyword value for integration search widget with document listing web component."
        },
        "attribute": "keyword",
        "reflect": false,
        "defaultValue": "''"
      },
      "userProfile": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "user-profile",
        "reflect": false,
        "defaultValue": "''"
      }
    };
  }
  static get events() {
    return [{
        "method": "documentListingReady",
        "name": "documentListingReady",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "Emit event when component is ready to work."
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }, {
        "method": "documentFavoriteCountChange",
        "name": "documentFavoriteCountChange",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "Emits when My Documents quantity changes"
        },
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        }
      }];
  }
}
